export default "__VITE_ASSET__BFcW1AA1__"